import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.scss';

const root = document.getElementById('at-wayfinding-mini');
window.atWayfindingMiniVersion = process.env.REACT_APP_VERSION;
ReactDOM.render(<App {...(root.dataset)} />, root);
